import React, { useRef } from "react";
import { func, string } from "prop-types";
import ReactDatePicker from "react-datepicker";
import ButtonDropdown from "../ButtonDropdown/ButtonDropdown.jsx";

import {
  formatDateForUrl,
  formatDateForFrontend,
  parseUrlDate,
} from "../../common/date.js";
import isToday from "date-fns/isToday";

const propTypes = {
  onChange: func.isRequired,
  date: string, // date as string in format from date.js
};

const DatePicker = props => {
  const { onChange, date: urlFormattedDate } = props;

  const buttonRef = useRef();

  const selectedDate = parseUrlDate(urlFormattedDate);
  const dateIsToday = isToday(selectedDate);

  const changeDate = date => {
    onChange(formatDateForUrl(date));

    if (buttonRef.current) {
      buttonRef.current.closeDropdown();
    }
  };

  return (
    <ButtonDropdown
      ref={buttonRef}
      className="date-picker"
      button={
        dateIsToday ? "Move in date" : formatDateForFrontend(selectedDate)
      }
      showClearButton={!dateIsToday}
      onClearClick={() => changeDate(new Date())}
    >
      <ReactDatePicker
        inline
        selected={selectedDate}
        onChange={changeDate}
        minDate={new Date()} // today
      />
    </ButtonDropdown>
  );
};

DatePicker.propTypes = propTypes;
export default DatePicker;
